/**
 * Create a single component to handle internal and external links.
 * @link https://github.com/henrikwirth/gatsby-starter-wordpress-twenty-twenty/blob/master/src/components/UniversalLink.js
 */
import * as React from "react";
import { Link as GatsbyLink } from "gatsby";
// import AdvancedLink from "§/src/utils/AdvancedLink"
import { advancedLinkPost } from "§/src/utils/AdvancedLinkPost"
import { advancedLinkTerm } from "§/src/utils/AdvancedLinkTerm"

// Since DOM elements <a> cannot receive activeClassName
// and partiallyActive, destructure the prop here and
// pass it only to GatsbyLink
const UniversalLink = ({
  children,
  to,
  activeClassName,
  partiallyActive,
  uri,
  target,
  hash,
  ...other
}) => {

  let targetAttr = target || "_self"
  let linkUrl = '#' // Valore di default sicuro

  // Advanced Link
  // check if is array
  if (Array.isArray(to)) {
    // Target attribute
    if(to[3] === "1") {
      targetAttr = '_blank'
    }

    // Get uri from post id
    if(to[0] === 'post') {
      const postData = advancedLinkPost(to)
      linkUrl = postData && postData.length > 0 && postData[0]?.uri ? postData[0].uri : '#'
    } else if(to[0] === 'term') {
      const termData = advancedLinkTerm(to)
      linkUrl = termData && termData.length > 0 && termData[0]?.uri ? termData[0].uri : '#'
    } else { // url
      linkUrl = to[1] || '#'
    }
  } else {
    // Normal link
    linkUrl = to || '#'
  }

  // Hash in dynamic url
  if(hash) {
    linkUrl = linkUrl + '#' + hash
  }

  // Tailor the following test to your environment.
  // This example assumes that any internal link (intended for Gatsby)
  // will start with exactly one slash, and that anything else is external.
  const internal = linkUrl && typeof linkUrl === 'string' && /^\/(?!\/)/.test(linkUrl);

  // Use Gatsby Link for internal links, and <a> for others
  if (internal && targetAttr !== '_blank') {
    return (
      <GatsbyLink
        to={linkUrl}
        activeClassName={activeClassName}
        partiallyActive={partiallyActive}
        uri={uri}
        target={targetAttr}
        {...other}
      >
        {children}
      </GatsbyLink>
    );
  }
  return (
    <a href={linkUrl} target={targetAttr} {...other} uri={uri}>
      {children}
    </a>
  );
};
export default UniversalLink;
